import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 25 25",
    color: "#1F1F1F",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M12.103 20.03a2.403 2.403 0 1 0 0-4.805 2.403 2.403 0 0 0 0 4.806" fill="currentColor"/> <path d="M12.759 10.93a.655.655 0 0 0-1.311 0v4.368a.655.655 0 1 0 1.31 0z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.103 4.333a1.68 1.68 0 0 0-1.677 1.81l.002.028V14.3l-.318.224a3.66 3.66 0 0 0-1.553 3.007v.014a3.546 3.546 0 1 0 7.092 0v-.014a3.66 3.66 0 0 0-1.554-3.007l-.318-.224V6.17l.003-.028a1.68 1.68 0 0 0-1.677-1.81M10.83 3.099a3.182 3.182 0 0 1 4.447 3.127v7.315a5.16 5.16 0 0 1 1.872 3.99 5.047 5.047 0 0 1-9.728 1.945 5 5 0 0 1-.364-1.946 5.16 5.16 0 0 1 1.871-3.99V6.227A3.18 3.18 0 0 1 10.83 3.1" fill="currentColor"/>' }
  })
);